import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  OnInit,
  input,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {
  AbsenceUnitArray,
  AbsenceUnitEnum,
} from '@qaroni-app/absences/types/absence-unit.enum';
import { QaroniBaseFormsDirective } from '@qaroni-core/directives/qaroni-base-forms/qaroni-base-forms.directive';

@Component({
  selector: 'qaroni-absences-unit-select',
  templateUrl: './absences-unit-select.component.html',
  styleUrl: './absences-unit-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AbsencesUnitSelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class AbsencesUnitSelectComponent
  extends QaroniBaseFormsDirective
  implements OnInit, ControlValueAccessor
{
  readonly units = input<AbsenceUnitEnum[]>(AbsenceUnitArray);

  public control = new FormControl<AbsenceUnitEnum>(AbsenceUnitEnum.DAYS);
  private controlChanges$ = this.control.valueChanges;

  ngOnInit(): void {
    this.subs.add(this.controlChanges$.subscribe(this.getControlChanges));
  }

  get hasUnits(): boolean {
    const units = this.units();
    return units && units.length > 0;
  }

  public onChange: (value: AbsenceUnitEnum) => void = () => {};
  public onTouched = () => {};

  public writeValue(value: AbsenceUnitEnum): void {
    this.control.setValue(value, { emitEvent: false });
  }

  public registerOnChange(fn: (value: AbsenceUnitEnum) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable({ emitEvent: false });
    }
  }

  private getControlChanges = (value: AbsenceUnitEnum) => {
    this.onChange(value);
    this.onTouched();
  };
}
